export function getAddress(state) {
  return state.address;
}

export function getAddressById(state, addressId) {
  return getAddress(state).get(addressId);
}
